import { render, staticRenderFns } from "./StatisticsGroup.vue?vue&type=template&id=4f9d99d0&scoped=true&"
import script from "./StatisticsGroup.vue?vue&type=script&lang=js&"
export * from "./StatisticsGroup.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsGroup.vue?vue&type=style&index=0&id=4f9d99d0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9d99d0",
  null
  
)

export default component.exports